import $ from 'jquery';

$(document).ready(function() {
  if (!$('textarea#request_destination_pmp_report_link_msg').length) return;
  if (!window.tinymce) return;

  window.tinymce.init({
    license_key: 'gpl', // still free to use under GPL: https://www.tiny.cloud/docs/tinymce/latest/license-key/?utm_campaign=console_license_key_message&utm_source=tinymce&utm_medium=referral
    selector: 'textarea#request_destination_pmp_report_link_msg',
    menubar: false,
    plugins: [
      'autolink',
      'link',
      'wordcount',
    ].join(' '),
    toolbar: 'styles | bold italic underline | link',
    fontsize_formats: '8px 10px 12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 32px 34px 36px',
    branding: false,
    skin: false,
    content_css: false,
    content_style: 'body { font-family: Arial; }',
    inline_styles: false,
    link_target_list: false,
    default_link_target: '',
    link_title: true,
    link_assume_external_targets: true,
    link_default_protocol: 'https',
    formats: {
      underline: { inline: 'u', exact: true },
    },
    style_formats: [
      { title: 'Headings', items: [
        { title: 'Heading 1', format: 'h1' },
        { title: 'Heading 2', format: 'h2' },
        { title: 'Heading 3', format: 'h3' },
        { title: 'Heading 4', format: 'h4' },
        { title: 'Heading 5', format: 'h5' },
        { title: 'Heading 6', format: 'h6' },
      ]},
      { title: 'Inline', items: [
        { title: 'Bold', format: 'bold' },
        { title: 'Italic', format: 'italic' },
        { title: 'Underline', format: 'underline' },
      ]},
      { title: 'Blocks', items: [
        { title: 'Paragraph', format: 'p' },
        { title: 'Blockquote', format: 'blockquote' },
        { title: 'Div', format: 'div' },
      ]},
    ],
    setup: function(ed) {
      ed.on('change', function() {
        $('#previewHtml').html(ed.getContent().replace(/</g, "&lt;").replace(/>/g, "&gt;"));
        $('#alt_message').val(ed.getContent());
      });
    },
  });
});
